import React from "react";
import { Context, IContext } from "ui/atoms/Form/context";

export function useForm(): IContext {
  const value = React.useContext(Context);

  return value;
}
